import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { PreviewPrint } from '@app/src/common/PreviewPrint';
import { CategoryModel } from '@app/src/views/Home/listProducts';
import {
  Item,
  Description,
  List,
  Title,
  IconInfo,
  ModalContent,
  Subtitle,
  Available
} from './styled';
import { Icon } from '@app/src/common/Icon';
import {
  VignetteOptionModal,
  selectExtracharge,
  fetchVignette,
  setVignetteValue,
  FormActions,
  TypePublicationModel,
} from '@app/src/views/StepTwo/channelPublication';
import { Modal } from '@app/src/common/Modal';
import { COLORS } from '@app/src/ui';
import { isClientEnv } from '@app/src/utils/validations';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';
import { Checkbox } from '@app/src/common/Checkbox';

const isClient = isClientEnv();

interface Props {
  isShowPhotoUploader?: boolean;
  getPrice?: Function;
  printDataId: number;
  availablePhotos?: number;
}

export const SectionExtrachargesConsume: React.FC<Props> = ({
  isShowPhotoUploader,
  getPrice,
  printDataId,
  availablePhotos
}) => {
  const dispatch = useDispatch();
  const { packageId } = useParams();
  const [isOpenModalVignette, setIsOpenModalVignette] = useState(false);
  const [settings, setSettings] = useState({
    bold: false,
    titleCenter: false,
    highlight: false,
    starCount: null,
    header: '',
    vignette: false,
    vignetteValue: ''
  });
  const history = useHistory();
  const printStorage = isClient && JSON.parse(sessionStorage.getItem('print'));
  const categoryId = printStorage.general.category;
  const categoryConfig: CategoryModel = CATEGORIES[CATEGORY[categoryId]];

  const [fromInput, setFromInput] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);

  const currentChannel: TypePublicationModel = useSelector(state => state.typePublication.selected);
  const newspaperId = currentChannel && currentChannel.newspaperId;
  const channelId = currentChannel && currentChannel.id;
  const extracharges = useSelector(state => state.extracharge.data);
  const currentExtracharge = extracharges && extracharges[channelId];
  const { title, description, category } = useSelector(state => state.print.general);
  const printExtracharges = useSelector(state => state.print.extracharges);
  const vignettes = useSelector(state => state.vignette.data);
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const printData = useSelector(state => state.print);
  const counter = useSelector(state => state.myPackageAvailable.counter);
  const counterBoth = counter && counter.both;
  const typeUserAction = useSelector(state => state.session.user.pasarella);

  useEffect(() => {
    if (printExtracharges && printExtracharges[printDataId] && printExtracharges[printDataId].vignette) {
      dispatch(setVignetteValue(printDataId, printExtracharges[printDataId].vignette));
    }
    if (currentExtracharge && currentExtracharge.data && currentExtracharge.data.length > 0) {
      let obj = {};
      let priceIgv = 0;
      let price = 0;
      currentExtracharge.data.map((item) => {
        if (item.checked === true) {
          obj[item.style] = item.styleValue;
          priceIgv = priceIgv + item.priceIgv;
          price = price + item.price;
          if (item.style === 'vignette' && currentExtracharge.vignette) {
            obj['vignetteValue'] = currentExtracharge.vignette.name;
          }
        } else {
          if (item.style === 'vignette') {
            obj['vignetteValue'] = '';
          }
        }
      });
      getPrice && getPrice({
        price,
        priceIgv
      });
      setSettings({
        ...settings,
        ...obj
      });
    }
  }, [currentExtracharge]);

  useEffect(() => {
    if (settings && settings.vignette && vignettes && vignettes.length === 0) {
      dispatch(fetchVignette(category, printDataId));
    }
  }, [settings.vignette, vignettes]);

  useEffect(() => {
    if (print && !isNotAnyPrint(printsByChannel) && isClient) {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }
    }
  }, [printsByChannel]);


  const handleBeforeUnload = (e) => {
    const newPrint = { ...printData };
    newPrint['printsByChannel'] = {};
    newPrint['summaryId'] = '';
    newPrint['token'] = '';
    newPrint['extracharges'] = {};
    newPrint['priceTotal'] = {};
    newPrint['photoVignette'] = {};
    isClient && sessionStorage.setItem('print', JSON.stringify(newPrint));
    e.returnValue = '¿Desea descartar cambios?';
  };

  const isNotAnyPrint = (printsByChannel) => {
    let isNotPrint = true;
    let channelsId = printsByChannel && Object.keys(printsByChannel);
    if (channelsId && channelsId.length > 0) {
      channelsId.forEach((key) => {
        isNotPrint = isNotPrint && (printsByChannel && printsByChannel[key] && printsByChannel[key].length === 0)
      })
    }
    return isNotPrint;
  };

  const handleChangeCheckbox = (_isChecked, index, item) => {
    let currentPrints = printsByChannel[channelId].length || 0;
    if (currentPrints > item.quantity && item.quantity !== 0 || item.quantity === 0 && !item.checked) {
      alert('Extracargos insuficientes. Recuerde consume un extracargo por cada fecha seleccionada');
      return;
    }
    let extraConsume = item.quantity;

    if (_isChecked) {
      extraConsume = item.quantity - (currentPrints);
      setSettings({
        ...settings,
        [item.style]: item.styleValue
      });
      if (item.input === 'vignette') {
        setIsOpenModalVignette(true);
        setFromInput(true);
      }
    } else {
      extraConsume = item.quantity + (currentPrints);
      setSettings({
        ...settings,
        [item.style]: null
      });
    }
    setExtrachargeByNewspaper(item, index, _isChecked, extraConsume);
  };

  const setExtrachargeByNewspaper = (item, index, isChecked, quantity) => {
    const group = { 1: [1, 3], 2: [2, 4, 5] };
    const groupBoth = { 1: 2, 2: 1 };
    const currentGroup = group[newspaperId];
    currentGroup.map(channel => {
      const beforeItem = extracharges[channel].data.filter(x => x.extrachargeId === item.extrachargeId)[0];
      if (channel === channelId) {
        dispatch(selectExtracharge(channel, item.extrachargeId, isChecked, quantity));
      } else {
        dispatch(selectExtracharge(channel, item.extrachargeId, beforeItem && beforeItem.checked, quantity));
      }
    })
    if (counterBoth && counterBoth[item.extrachargeId]) {
      const lastNewspaper = groupBoth[newspaperId];
      const alternGroup = group[lastNewspaper];
      alternGroup.map(channel => {
        const beforeItem = extracharges && extracharges[channel] && extracharges[channel].data.filter(x => x.extrachargeId === item.extrachargeId)[0];
        if (channel === channelId) {
          dispatch(selectExtracharge(channel, item.extrachargeId, isChecked, quantity));
        } else {
          dispatch(selectExtracharge(channel, item.extrachargeId, beforeItem && beforeItem.checked, quantity));
        }
      });
    }
  };

  const handleClickCloseModal = useCallback((item) => {
    if (settings && !settings.vignetteValue && !item) {
      dispatch(selectExtracharge(printDataId, item.extrachargeId, false));
      setSettings({
        ...settings,
        vignetteValue: null
      });
    }
    setIsOpenModalVignette(false);
  }, [dispatch]);

  const handleChangeVignette = useCallback((item) => {
    dispatch(setVignetteValue(printDataId, item));
    setSettings({
      ...settings,
      vignetteValue: item.name
    });
    setIsOpenModalVignette(false);
  }, [settings]);

  const handleClickEditVignette = () => {
    setFromInput(false)
    setIsOpenModalVignette(true);
  };

  const handleCloseModal = () => {
    setIsShowModal(false)
  };

  const handleClickIconInfo = () => {
    setIsShowModal(true);
  };

  const getDisplayExtracharges = (item) => (item.alias !== 'fotovineta' && item.alias !== 'palabra-extra') ? true : false;

  const handleClickBack = () => {
    history.push(`${categoryConfig.paths.consumePackage.stepCalendar}/${packageId}`);
  };

  const handleClickNext = () => {
    history.push(`${categoryConfig.paths.consumePackage.stepTypePublication}/${packageId}`);
  };

  return (
    <React.Fragment>
      <Title>
        <span>Vista referencial</span> <IconInfo onClick={handleClickIconInfo}><Icon data-name="icon-info" width="14" height="14" fill={COLORS.BLACK} /></IconInfo>
      </Title>
      <Modal show={isShowModal} closeModal={handleCloseModal}>
        <ModalContent>
          Algunos destaques no se pueden combinar. Por ejemplo: Estrellas con viñetas o con los Encabezados.
        </ModalContent>
      </Modal>
      <VignetteOptionModal
        modalTitle="Seleccione viñeta"
        show={isOpenModalVignette}
        handleClickCloseModal={handleClickCloseModal}
        colorTheme={categoryConfig.color}
        handleChangeRadioInput={handleChangeVignette}
        initialValue={settings && settings.vignetteValue}
        origin={fromInput}
      />
      <PreviewPrint
        channelId={printDataId}
        title={title}
        words={description}
        colorTheme={categoryConfig.color}
        isShowPhotoUploader={isShowPhotoUploader}
        availablePhotos={(typeUserAction === 'consume-print' && newspaperId !== 2) && availablePhotos}
        handleClickEditVignette={handleClickEditVignette}
        isEditable
        {...settings}
      />
      <Subtitle>¿Quieres agregar adicionales?</Subtitle>
      <List>
        {
          currentExtracharge && currentExtracharge.data && currentExtracharge.data.length > 0 &&
          currentExtracharge.data.map((item, index) => (
            <Item key={index} isDisplay={getDisplayExtracharges(item)}>
              <Checkbox
                handleChange={(isChecked) => handleChangeCheckbox(isChecked, index, item)}
                name={item && item.input}
                value={item && item.value}
                colorActive={COLORS.BLUE_LINK}
                disabled={item && item.disabled}
                checked={item && item.checked}
              >
                <Description>
                  {item && item.name} {
                    <Available>Disponibles: {item.quantity || 0}</Available>
                  }
                </Description>
              </Checkbox>
            </Item>
          ))
        }
      </List>
      <FormActions
        textButtonBack={'Regresar'}
        handleButtonBack={handleClickBack}
        handleButtonNext={handleClickNext} />
    </React.Fragment>
  )
};
